<style scoped="" type="text/css"></style>
<template>
	<el-input style="width: 0;height: 0;opacity: 0;;" ref="cardReaderInput" v-model="value" @change="change" @focus="focus" @blur="blur"></el-input>

</template>
<script type="text/javascript">
export default {
	name: 'yi_card_reader',
	components: {},
	props: {


	},
	data() {
		return {
			timer: null,
			value: '',
			message: null,
		}
	},
	watch: {

	},
	created() {
		this.timer = setInterval(() => {
			console.log(this.value)

			//检测dom是否有存在其他聚焦的输入框，没有的话，聚焦cardReaderInput
			const focusInput = document.activeElement;
			//判断focusInput类型是否输入框
			if (focusInput.tagName === 'INPUT' || focusInput.tagName === 'TEXTAREA') {
				return;
			}
			this.$refs.cardReaderInput.focus();

			console.log('等待刷卡')

		}, 500)
	},

	mounted() {



	},
	destroyed() {
		clearInterval(this.timer)
	},
	computed: {



	},
	methods: {
		change() {
			console.log('change', this.value)
			if (this.value == '') {
				return
			}
			this.$emit('cardReaded', this.value)
			//几秒后清空value
			setTimeout(() => {
				this.value = ''
			}, 1000)
		},
		focus() {
			// this.message = this.$message({
			// 	showClose: false,
			// 	message: 'dengdaishuaka...',
			// 	duration: 0,
			// });

		},
		blur() {
			// this.message.close()
		}
	}
}
</script>
